/**
 * Deferred - a promise that can be resolved from outside (like $.Deferred)
 * @module
 */
var _ = require('optimizely-client-fn');

var PromiseEnv = require('../lib/promise').Promise;

var Deferred = function() {
  var resolver, rejecter;

  var dfd = new PromiseEnv(function(resolve, reject) {
    resolver = resolve;
    rejecter = reject;
  });

  dfd.resolve = function() {
    resolver.apply(null, _.toArray(arguments));
    return dfd;
  };
  dfd.reject = function() {
    rejecter.apply(null, _.toArray(arguments));
    return dfd;
  };

  return dfd;
};

module.exports = Deferred;


